import React                   from 'react';
import styled                  from 'styled-components';
import { Button as MuiButton } from '@material-ui/core';
import { ButtonProps }         from '@material-ui/core/Button';
import { Progress }            from '@components/Progress/Progress';

interface IProps extends ButtonProps {
  isLoading?    : boolean;
  isWithLoader? : boolean;
  loaderColor?  : string;
  label?        : string;
  width?        : string;
  margin?       : string;
  bgcolor?      : string;
  textcolor?    : string;
  onClick?      : (props?: any) => void;
}

const StyledButton = styled(MuiButton)`
&& {
  overflow    : hidden;
  white-space : nowrap;

  ${({ margin }: any): string => margin && `margin: ${margin}`};
  ${({ width }: any): string => width && `min-width: ${width} !important`};

  ${({ variant, theme: { textColor } }): any =>
    variant === 'contained' && `color: ${textColor.white}`};


  color: ${
  ({ textcolor, theme: { textColor } }: any): false | string => (
    textcolor && textColor[textcolor]
  )};

  background-color: ${(
    { bgcolor, theme: { backgroundColor } },
  ): false | string => (
    bgcolor && backgroundColor[bgcolor]
  )};

  span:first-child {
    margin-left: 15px;
  }

  :disabled {
    ${({ variant, theme: { textColor } }): false | string =>
    variant === 'contained' && `color: ${textColor.white}`};

    ${({ variant, theme: { backgroundColor } }): false | string =>
    variant === 'contained' && `background-color: ${backgroundColor.gray}`};
  }

  > span {
    display: flex;
  }

  svg {
    margin-right: 10px;
  }
}
` as any;

export const Button: React.FC<IProps> = ({
  loaderColor  = 'white',
  isWithLoader = true,
  ...props
}) => (
  <StyledButton {...props}>
    {props.children ?? props.label}

    {isWithLoader && (
      <Progress
        loading     = {props.isLoading}
        loaderColor = {loaderColor}
      />
    )}
  </StyledButton>
);

Button.defaultProps = {
  color         : 'secondary',
  variant       : 'contained',
  disableRipple : true,
};
